import { tokens } from './tokens';
/**
 * Media query function which will return a max-width media query with the breakpoint provided
 */
export const mq = (level) => `@media (max-width: ${tokens.breakpoints[level]})`;
